import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-041a4e74"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-3"
}, null, -1));
const _hoisted_5 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12 mb-3"
};
const _hoisted_8 = {
  key: 0,
  class: "fw-medium fsi-14 d-flex justify-content-center align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_9 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_10 = {
  key: 1,
  class: "fw-medium fsi-14 d-flex justify-content-center align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_11 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_12 = {
  style: {
    "margin-top": "1rem"
  },
  class: "col-12"
};
const _hoisted_13 = {
  key: 1,
  class: "i-layer"
};
const _hoisted_14 = {
  class: "row"
};
const _hoisted_15 = {
  class: "col-12 mb-3"
};
const _hoisted_16 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_17 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_18 = {
  "element-loading-text": "Loading...",
  style: {
    "min-height": "100px"
  }
};
const _hoisted_19 = {
  key: 0,
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_20 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_21 = {
  key: 1,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_22 = {
  key: 1,
  style: {
    "margin-top": "2rem"
  }
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mb-3 mt-3"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mb-1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-18"
}, "Terminate Guarantee For Node")])], -1));
const _hoisted_25 = {
  class: "row mt-3"
};
const _hoisted_26 = {
  class: "col-12"
};
const _hoisted_27 = {
  key: 0,
  class: "row mb-3 i-layer"
};
const _hoisted_28 = {
  class: "col-12 mb-1"
};
const _hoisted_29 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_30 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_button = _resolveComponent("el-button");
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Singer = _resolveComponent("Singer");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Node')) + " f0" + _toDisplayString($props.nodeId), 1)]), _hoisted_4, $data.noGuaranteeNode ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [$data.noGuaranteeNodeErrNodeId !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, [_createTextVNode(_toDisplayString(_ctx.$t('farm.Node')) + " ", 1), _createVNode(_component_router_link, {
    onClick: $options.gotoOtherNode,
    class: "link-text",
    replace: true,
    to: `/farm/provider/${$data.noGuaranteeNodeErrNodeId}`
  }, {
    default: _withCtx(() => [_createTextVNode("f0" + _toDisplayString($data.noGuaranteeNodeErrNodeId), 1)]),
    _: 1
  }, 8, ["onClick", "to"]), _createTextVNode(" " + _toDisplayString($data.noGuaranteeNodeErr), 1)])])) : _createCommentVNode("", true), $data.noGuaranteeNodeErrNodeId === '' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString($data.noGuaranteeNodeErr), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.back,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.return')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])])])) : _createCommentVNode("", true), !$data.noGuaranteeNode ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('farm.Unsecured node')), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [!$data.loadingNode ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString($data.guaranteeNodeId), 1), !$data.isCopy && $options.nodeInfo.worker !== '' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.copy && $options.copy(...args)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_21, " copied ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !$data.readySign && !$data.loadingNode ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_button, {
    disabled: $data.noGuaranteeNode,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.reapprove,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["disabled", "onClick", "loading"])])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loadingNode]])])]), $data.readySign ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_Singer, {
    ref: "singer",
    nodeRole: $data.nodeRole,
    singerMultiple: $data.singerMultiple,
    singerType: "approval",
    waitTime: 30000,
    btnProposal: "Send Proposal",
    "contract-method": $data.contractMethod,
    contractParams: $data.contractParams,
    onNext: $options.complete,
    originalSingerTables: $data.singerTables
  }, null, 8, ["nodeRole", "singerMultiple", "contract-method", "contractParams", "onNext", "originalSingerTables"])])]), $data.showCancel && !$data.completeFlag ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.cancel')), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true), $data.completeFlag ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_AdCard2, {
    title: `${_ctx.$t('farm.You have successfully released the collateralized node')}(${$data.guaranteeNodeId})`,
    "btn-text": _ctx.$t('Onboarding.View Node'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "btn-text", "onBtnClick"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}